import RobotMascot from "./RobotMascot";
import { scrollToId } from "../lib/scroll";

const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-black/5 py-16">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
        <div>
          <div className="flex items-center gap-2.5">
            <RobotMascot className="w-9" />
            <span className="font-display text-xl font-bold tracking-tight text-[#0A1628]">
              Lend<span className="text-[#007AFF]">Robot</span>
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm text-[#52525B]">
            Lending, engineered for humans. Fast decisions, honest numbers, a robot that blinks.
          </p>
        </div>

        <nav className="flex gap-16">
          <div>
            <p className="label-mono text-[#52525B] mb-4">Explore</p>
            <ul className="space-y-3 text-sm text-[#0A1628]">
              {[["how", "How it works"], ["bridge", "Micro advances"], ["products", "Loans"], ["faq", "FAQ"]].map(([id, label]) => (
                <li key={id}>
                  <button data-testid={`footer-link-${id}`} onClick={() => scrollToId(id)} className="hover:text-[#007AFF] transition-colors">
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="label-mono text-[#52525B] mb-4">Legal</p>
            <ul className="space-y-3 text-sm text-[#52525B]">
              <li>Rates & terms</li>
              <li>Privacy policy</li>
              <li>Responsible lending</li>
            </ul>
          </div>
        </nav>
      </div>

      <div className="mt-14 pt-8 border-t border-black/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="mono text-[11px] text-[#52525B]">
          © 2025 LendRobot Systems — lendrobot.com. Concept landing page: rates, figures and
          testimonials are illustrative samples.
        </p>
        <p className="mono text-[11px] text-[#52525B]">All lending subject to approval.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
